var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0639 9.64815L24.5554 1.59619C21.4186 -0.601618 16.6034 -0.481738 13.5864 1.85593L3.57643 9.66813C1.57842 11.2266 0 14.4234 0 16.9408V30.727C0 35.8219 4.13587 39.9778 9.23078 39.9778H30.7692C35.8641 39.9778 40 35.8419 40 30.747V17.2005C40 14.5033 38.2617 11.1866 36.0639 9.64815ZM21.4985 31.9857C21.4985 32.8049 20.8192 33.4842 20 33.4842C19.1808 33.4842 18.5015 32.8049 18.5015 31.9857V25.9917C18.5015 25.1725 19.1808 24.4932 20 24.4932C20.8192 24.4932 21.4985 25.1725 21.4985 25.9917V31.9857Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d6ddfac20f0ff7763edc560193800f72.svg";
export { ForwardRef as ReactComponent };